import { supabase } from "utils/supabaseClient";

export async function backendFunction(route, options = {}) {
    const {
        method = "POST",
        body,
        withAuth = false,
        headers = {},
    } = options;

    let token;

    if (withAuth) {
        const { data: sessionData, error: sessionErr } = await supabase.auth.getSession();
        if (sessionErr || !sessionData.session?.access_token) {
            return { error: "Authentication required" };
        }
        token = sessionData.session.access_token;
    }

    try {
        const res = await fetch(`/api/${route}`, {
            method,
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...headers,
            },
            ...(body ? { body: JSON.stringify(body) } : {}),
        });

        const contentType = res.headers.get("content-type") || "";
        const isJSON = contentType.includes("application/json");
        const result = isJSON ? await res.json() : await res.text();

        if (!res.ok) {
            const errorMessage = typeof result === "string"
                ? result
                : [result?.error, result?.details].filter(Boolean).join(": ") || "Unknown error";

            return {
                error: errorMessage,
            };
        }

        return { data: result };
    } catch (err) {
        console.error("Function call error:", err);
        return { error: err.message || "Request failed" };
    }
}
